













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BaseDropDown from '@/components/DropDowns/BaseDropDown.vue';

@Component({
    components: {
        BaseDropDown,
    },
})
export default class LanguagesDropDown extends Vue {
    @Prop() public assignedLanguages: any;

    public showLanguagesDropDown: boolean = false;
    public selectedLanguages: any = [];
    public selectedLanguage: any = null;

    constructor() {
        super();
    }

    get languages() {
        return this.$store.getters['Localization/getAllLanguages'];
    }

    @Watch('selectedLanguage')
    public selectedLanguageChanged() {
        this.$emit('selectedLanguageChanged', this.selectedLanguage);
    }

    public selectLanguage(language: any) {
        this.selectedLanguage = language;
    }

    public addLanguage(langauge: any) {
        if (!this.languageIsSelected(langauge)) {
            this.selectedLanguages.push(langauge);
            this.$emit('languageAdded', langauge);
            this.selectLanguage(langauge);
        }

        this.showLanguagesDropDown = false;
    }

    public removeLanguage(langauge: any) {
        if (this.selectedLanguages.length <= 1) {
            return;
        }

        this.selectedLanguages = this.selectedLanguages.filter((lang: any) => lang.id !== langauge.id);
        this.showLanguagesDropDown = false;

        if (this.selectedLanguages.length === 1) {
            this.selectLanguage(this.selectedLanguages[0]);
        }

        this.$emit('languageDeleted', langauge);
    }

    public languageIsSelected(langauge: any) {
        return this.selectedLanguages.some((lang: any) => lang.id === langauge.id);
    }

    public created() {
        this.selectedLanguages = typeof this.assignedLanguages !== 'undefined' && this.assignedLanguages.length
            ? this.languages.filter((lang: any) => this.assignedLanguages.includes(lang.id))
            : this.selectedLanguages = this.languages.filter((lang: any) => lang.key === 'en');

        this.selectedLanguage  = this.selectedLanguages[0];

        this.$emit('initLanguages', this.selectedLanguages);
    }
}
